import { Icon } from '@iconify/react';
import { EMPLOYEE_TYPES, getAuthContext } from '../../../utils/roleAccess';

const icon = (name) => <Icon icon={name} width={22} height={22} />;

/**
 * Primary bottom-tab definitions per role.
 * Hub scan + delivery scans sit together whenever the role can use them.
 */
const TABS_BY_ROLE = {
  admin: [
    { key: 'home', label: 'Home', path: '/home', icon: icon('solar:home-2-bold'), match: ['/home', '/dashboard-admin'] },
    { key: 'hub', label: 'Hub', path: '/scan-package', icon: icon('solar:qr-code-bold'), match: ['/scan-package', '/scanned-packages'] },
    { key: 'out', label: 'Out', path: '/scan-out-of-delivery', icon: icon('mdi:truck-delivery'), match: ['/scan-out-of-delivery', '/out-of-delivery-packages'] },
    { key: 'deliver', label: 'Deliver', path: '/delivered', icon: icon('mdi:package-check'), match: ['/delivered', '/delivery-lists'] },
  ],
  [EMPLOYEE_TYPES.MANAGER]: [
    { key: 'home', label: 'Home', path: '/home', icon: icon('solar:home-2-bold'), match: ['/home'] },
    { key: 'hub', label: 'Hub', path: '/scan-package', icon: icon('solar:qr-code-bold'), match: ['/scan-package', '/scanned-packages'] },
    { key: 'out', label: 'Out', path: '/scan-out-of-delivery', icon: icon('mdi:truck-delivery'), match: ['/scan-out-of-delivery', '/out-of-delivery-packages'] },
    { key: 'deliver', label: 'Deliver', path: '/delivered', icon: icon('mdi:package-check'), match: ['/delivered', '/delivery-lists'] },
  ],
  [EMPLOYEE_TYPES.STORE_INCHARGE]: [
    { key: 'home', label: 'Home', path: '/home', icon: icon('solar:home-2-bold'), match: ['/home'] },
    { key: 'hub', label: 'Hub', path: '/scan-package', icon: icon('solar:qr-code-bold'), match: ['/scan-package'] },
    { key: 'scanned', label: 'Scanned', path: '/scanned-packages', icon: icon('mdi:package-check'), match: ['/scanned-packages'] },
  ],
  [EMPLOYEE_TYPES.DELIVERY_PERSON]: [
    { key: 'home', label: 'Home', path: '/home', icon: icon('solar:home-2-bold'), match: ['/home'] },
    { key: 'out', label: 'Out', path: '/scan-out-of-delivery', icon: icon('mdi:truck-delivery'), match: ['/scan-out-of-delivery'] },
    { key: 'deliver', label: 'Deliver', path: '/delivered', icon: icon('mdi:package-check'), match: ['/delivered'] },
    { key: 'lists', label: 'Lists', path: '/delivery-lists', icon: icon('solar:clipboard-list-bold'), match: ['/delivery-lists', '/out-of-delivery-packages'] },
  ],
};

export const MORE_TAB = {
  key: 'more',
  label: 'More',
  path: null,
  icon: icon('eva:menu-2-fill'),
  match: [],
};

export const getMobileBottomTabs = () => {
  const { isAdmin, employeeType } = getAuthContext();
  if (isAdmin) {
    return [...TABS_BY_ROLE.admin, MORE_TAB];
  }

  const tabs = TABS_BY_ROLE[employeeType];
  if (tabs) {
    return [...tabs, MORE_TAB];
  }

  return [
    { key: 'home', label: 'Home', path: '/home', icon: icon('solar:home-2-bold'), match: ['/home'] },
    MORE_TAB,
  ];
};

export const isTabActive = (tab, pathname) => {
  if (!tab?.match?.length) {
    return false;
  }
  return tab.match.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
};

export const isMoreActive = (tabs, pathname) => {
  const primaryTabs = tabs.filter((tab) => tab.key !== 'more');
  return !primaryTabs.some((tab) => isTabActive(tab, pathname));
};
